import {
    ANNOTATION_PARENT,
    ANNOTATION_VIDEO_DISPLAY,
    VIDEO_PLAYING_MODE,
    VIDEO_SRC_TYPE
} from "../client-data/GlobalConstants";
import * as THREE from "three";
import {
    DEFAULT_VIDEO_PAUSE_SPRITE_IMAGE_URL,
    DEFAULT_VIDEO_PLAY_SPRITE_IMAGE_URL
} from "../client-data/clientOptions";
import {
    ANNOTATION_TEXT_ALIGNMENT,
    ANNOTATION_TEXT_LINE_HEIGHT, CONTACT_URL, ENQUIRE_EMAIL,
    HAS_MEDIA_CAROUSEL_LINK
} from "../client-data/AnnotationDB";


class VideosDBToAnnotationDBConverter {

    constructor() {
    }

    static createAnnotationDBFromVideoDBRecord(videoDBRecord) {
        if (videoDBRecord) {

            // console.log("[AnnotationDataController]: ", record.paintingId);

            //For now we are not using the "isSold" for almost anything!
            const isSold = 'N';
            // const isSendTo = 'N';
            // const hasChildren = 'N';
            let videoURL = videoDBRecord.videoUrl;
            let isAnnotationVideo = false;
            let isStandaloneVideo = false;
            // let isAnnotation = false;
            let isCSS3DObject = false;
            let isAudioPlayer = false;
            let displayType = ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO;
            // isAnnotationVideo = ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO;
            // isAnnotation = ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO;
            isStandaloneVideo = ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO;
            isCSS3DObject = ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO;
            isAudioPlayer = ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO;

            // const annotationScale = null;
            // const annotationPos = null;
            // const annotationRotation = null;
            const imageURL = null;
            // const iframeSource = null;
            // const hasCarouselAsParent = 'N';


            // let ContactURL = null;
            // let EnquireEmail = null;
            // let shareEmail = null;

            //this is pending for answer from Claire and Joe
            // let emailSubjectText = record.emailSubjectText || record.headerText;

            // if (record.ContactURL) {
            //     ContactURL = record.ContactURL;
            // }

            //"ENQUIRE" email link
            // if (record.EnquireEmail) {
            //     EnquireEmail = `mailto:${record.EnquireEmail}?subject=${emailSubjectText}`;
            // }
            // if (record.EnquireEmail) {
            //     if(record.emailBodyText) {
            //         // console.log("AnnotationDataController", record.emailBodyText);
            //         EnquireEmail = `mailto:${record.EnquireEmail}?subject=${emailSubjectText}&body=${record.emailBodyText}`;
            //     } else {
            //         EnquireEmail = `mailto:${record.EnquireEmail}?subject=${emailSubjectText}`;
            //     }
            //
            // }

            // "SEND TO" email link: this sends an email with the ContactURL to anyone (not specified).
            // if (isSendTo) {
            //     if (ContactURL) {
            //         shareEmail = `mailto:?subject= ${emailSubjectText} &body=${emailSubjectText}` + escape("\n") + encodeURIComponent(record.ContactURL);
            //     } else {
            //         shareEmail = `mailto:?subject= ${emailSubjectText} &body=${emailSubjectText}`;
            //     }
            // }





            // console.log("[AnnotationDataControl], hasChildren", record.paintingId, hasChildren);

            // let childPaintings = [];
            // if (hasChildren === 'Y') {
            //     //Create an array of objects of the child paintingId we have from record.childPaintingId
            //
            //     if (record.childPaintingId) {
            //         record.childPaintingId.map((cPantingId) => {
            //             childPaintings.push(AnnotationDataController.getAnnotationDataById(cPantingId));
            //         })
            //
            //     }
            // }
            // let carouselAnnotationSiblings = [];
            // if (hasCarouselAsParent === 'Y') {
            //     //Create an array of objects of the child paintingId we have from record.childPaintingId
            //
            //     // console.log("[AnnotationDataControl], hasCarouselAsParent", record.paintingId, hasCarouselAsParent);
            //
            //     if (record.carouselAnnotationSiblings) {
            //
            //         record.carouselAnnotationSiblings.map((cPantingId) => {
            //             carouselAnnotationSiblings.push(AnnotationDataController.getAnnotationDataById(cPantingId));
            //         })
            //     }
            // }


            // const videoButtonScale = null;
            // const videoButtonPos = null;

            const videoPlaySpriteImageURL = process.env.PUBLIC_URL + DEFAULT_VIDEO_PLAY_SPRITE_IMAGE_URL;
            const videoPauseSpriteImageURL = process.env.PUBLIC_URL + DEFAULT_VIDEO_PAUSE_SPRITE_IMAGE_URL;

            return ({
                moreText: null,
                headerText: videoDBRecord.headerText ? `<h6>${videoDBRecord.headerText}</h6>` : null,
                bodyText: videoDBRecord.bodyText,
                paintingId: videoDBRecord.videoId,
                imageUrl: null,
                isAnnotationVideo: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
                isAnnotation: ANNOTATION_VIDEO_DISPLAY.ANNOTATION_VIDEO,
                isStandaloneVideo: false,
                isCSS3DObject:false,
                isAudioPlayer:false,
                displayMesh: 'Y',
                redisplayMeshAfterVideoEnd: 'N',  //make the original mesh visible after video ends. not applicable for loop videos
                displayHeight: 100,
                videoURL: videoDBRecord.videoUrl,
                videoStreamURL: null, //used for HLS video live stream
                EnquireEmail: null,
                isSendTo: null,
                shareEmail: null,
                annotationScale: null,
                annotationPos: null,
                annotation_location: null, //can take one of the values of ANNOTATION_LOCATION in GlobalConstants. It will effect only individual sprite
                annotation_location_vert_offset: null,  //in meters. vertical offset. default is 0.0. If not used then DEFAULT_ANNOTATION_LOCATION_VERT_OFFSET is used
                annotation_location_horiz_offset: null , //in meters. horizontal offset. default is 0.0. If not used then DEFAULT_ANNOTATION_LOCATION_HORIZ_OFFSET
                annotation_location_z_offset: null , //in meters. depth (Z-axes) offset. default is 0.1. If not used then DEFAULT_ANNOTATION_LOCATION_Z_OFFSET
                annotationParent: ANNOTATION_PARENT.PARENT_MESH,
                isSold: 'N',
                socialMedia: 'N',
                spriteImageURL: null,
                hasMediaCarousel: 'N',
                hasOnlyMediaCarousel: 'N',
                mediaCarouselLinkLabel: HAS_MEDIA_CAROUSEL_LINK,
                mediaObjects: null,
                artistInspirationUrl: null,
                emailSubjectText: null,
                hasChildren: 'N',
                childPaintings: null,
                iframeSource: null,
                standaloneVideoElementId: videoDBRecord.videoElement,
                hasCarouselAsParent: 'N',
                carouselAnnotationSiblings: null,
                ContactURL: null,
                youtubeUrl: videoDBRecord.youtubeUrl || null,
                spotifyUrl: videoDBRecord.spotifyUrl || null,
                linkedInIUrl: videoDBRecord.linkedInIUrl || null,
                instagramUrl: videoDBRecord.instagramUrl || null,
                twitterUrl: videoDBRecord.twitterUrl || null,
                tiktokUrl: videoDBRecord.tiktokUrl || null,
                imdbUrl: videoDBRecord.imdbUrl || null,
                facebookUrl: videoDBRecord.facebookUrl || null,
                urlLink1Label:  videoDBRecord.urlLink1Label|| null,
                urlLink1: videoDBRecord.urlLink1 || null,
                urlLink2Label: videoDBRecord.urlLink2Label || null,
                urlLink2: videoDBRecord.urlLink2 || null,
                urlLink3Label: videoDBRecord.urlLink3Label || null,
                urlLink3: videoDBRecord.urlLink3 || null,
                videoAutoPlay: VIDEO_PLAYING_MODE.VIDEO_NOT_AUTO_PLAY, //auto play video
                videoAutoPlayDelay:0, //how long video will wait before playing. in melli seconds - 1000 is one second. 0 no delay
                videoButtonScale: null,
                videoButtonPos: null,
                video_button_location: null, //can take one of the values of ANNOTATION_LOCATION in GlobalConstants. It will effect only individual sprite
                video_button_vert_offset: null,  //in meters. vertical offset. default is 0.0. If not used then DEFAULT_ANNOTATION_LOCATION_VERT_OFFSET is used
                video_button_horiz_offset: null , //in meters. horizontal offset. default is 0.0. If not used then DEFAULT_ANNOTATION_LOCATION_HORIZ_OFFSET
                video_button_z_offset: null , //in meters. depth (Z-axes) offset. default is 0.1. If not used then DEFAULT_ANNOTATION_LOCATION_Z_OFFSET
                videoPlaySpriteImageURL: videoPlaySpriteImageURL,
                videoPauseSpriteImageURL: videoPauseSpriteImageURL,
                videoTextureEncoding: THREE.sRGBEncoding, //can be set to  THREE.LinearEncoding or THREE.sRGBEncoding
                videoLoop: false, // true/false value for video continues playing
                videoSrcType: VIDEO_SRC_TYPE.FROM_FILE,
                iiifSource: null,
                iiifMultiSource: null,
                chatIframeSource: null,
                isMediaUsed: 'Y',
                annotationTextAlignment: ANNOTATION_TEXT_ALIGNMENT || "center",
                annotationTextLineHeight: ANNOTATION_TEXT_LINE_HEIGHT || "1.5",
                contactUrlLabel: CONTACT_URL,
                enquireEmailLabel: ENQUIRE_EMAIL,
                chatSrc: null,
                chatTitle: null,
                useModalChatWindow: 'Y',
                annotationVideoStream: null,
                useVideoMeshButton: 'N',
                useVideoGroupMeshButton: 'N',
                videoGroupButtonId: null,
                displayAudioSprite: 'Y', //display the audio sprite as play button  default is 'Y' for yes
                useMeshButton: 'N', // use 3d buttons as the annotation button. Default is 'N'
                AudioVideoVolume: 1.0,
            });
        }

        return null;
    }
}

export default VideosDBToAnnotationDBConverter;